import { kebabCase } from 'lodash'

export const blogFormat = (data) => {
  let format = {}
  if (data) {
    const { markdownRemark } = data;
    format = markdownRemark.frontmatter
    format.allCategories = data.categories.group
    format.html = markdownRemark.html
  }
  return format
}
  
export const blogItemFormat = (data) => {
  const format = {
    categories: [],
    posts: []
  }
  if (data && data.posts) {
    if (data.categories.group) {
      format.categories = data.categories.group
    }
    if (data.posts.edges.length)
    format.posts = data.posts.edges.map((g) => {
      if (g.node && g.node.fields && g.node.fields.slug) {
        g.node.frontmatter.slug = g.node.fields.slug
      }
      if (g.node && g.node.frontmatter) {
        return g.node.frontmatter
      }
      return null
    })
  }
  return format
}

export const createLink = (value) => {
  let link = ""
  if (value) {
    link  = value.toLowerCase().split(" ").join("-")
  }
  return kebabCase(link)
}

export const addComma = (arr, index) => {
  const arrayLength = arr.length
  if (arr.length === 1 || arrayLength === index +1) {
    return null
  }
  if (arrayLength -1 === index + 1) {
    return ' and '
  }
  return `, `
}



// WEBPACK FOOTER //
// ./src/utils/whistle.js